import { axiosInstanceAutomatedBilling } from "../axios";
import { ClientCreate, ClientCreations, RequestResponse } from "../types";

export const getClient = async (id: number): Promise<RequestResponse> => {
  try {
    const response = await axiosInstanceAutomatedBilling.get(
      `/api/v1/client/${id}`
    );
    return {
      error: false,
      data: response.data.data
    };
  } catch (err: any) {
    console.error("Unable to fetch client: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: null
    };
  }
};

export const getClients: (
  pageNumber: number,
  pageSize: number
) => Promise<
  RequestResponse<{ records: ClientCreations[]; total: number }>
> = async (pageNumber, pageSize) => {
  try {
    const response = await axiosInstanceAutomatedBilling.get(
      "/api/v1/client/all",
      {
        params: { pageNumber, pageSize }
      }
    );

    return {
      error: false,
      data: {
        records: response.data.data.clients,
        total: response.data.data.totalCount
      }
    };
  } catch (err: any) {
    console.error("Unable to fetch clients: ", { err });
    return {
      error: true,
      message: err.response.data?.message || err.message || err,
      data: null
    };
  }
};

export const updateClient = async (
  id: number,
  payload: ClientCreate
): Promise<RequestResponse> => {
  try {
    const updatedPayload = {
      id,
      ...payload
    };
    await axiosInstanceAutomatedBilling.put(
      `/api/v1/client/${id}`,
      updatedPayload
    );
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to update client: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};

export const createClient = async (
  payload: ClientCreate
): Promise<RequestResponse> => {
  try {
    await axiosInstanceAutomatedBilling.post(`/api/v1/client`, payload);
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to create client: ", err);
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};
